// All Routes
export const HOME_URL = "/";
export const DASHBOARD_URL = "/dashboard";
export const MANAGE_CLIENT_URL = "/clients-list";
export const VIEW_CLIENT_URL = "/view-client/:id";
export const MANAGE_PROJECT_URL = "/manage-project/:id";
export const MANAGE_COMPLIANCE_URL = "/manage-compliance";
export const MANAGE_CCF_POINTS_URL = "/manage-cff-points";
export const EDIT_CCF_POINT_URL = "/edit-cff-point/:id";
export const ADD_CCF_POINT_URL = "/add-ccf-point";
export const NOTIFICATION_URL = "/notifications";
export const SUPPORT_URL = "/support";
export const VIEW_SUPPORT_URL = "/suppot-ticket/:id";
export const MANAGE_LICENSE_URL = "/manage-license/:id";
export const NOT_FOUND_URL = "/not-found";
export const LOGIN_URL = "/login";
export const FORGOT_PASSWORD_URL = "/forgot-password";

// Dhanush Routes
export const MANAGE_FRAMEWORK_URL = "/manage-framework";
export const MANAGE_COMMANDS_URL = "/manage-commands";